import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMemberChoose: false,
};

export const ChooseMemberSlice = createSlice({
  name: "setChooseMember",
  initialState,
  reducers: {
    setIsMemberChoose: (state, action) => {
      state.isMemberChoose = action.payload;
    },
  },
});

export const { setIsMemberChoose } = ChooseMemberSlice.actions;
export default ChooseMemberSlice.reducer;
